import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { useMemo, useState, useEffect } from 'react';
import { Box } from '../../../primitives/Box/Box.es.js';
import '../../../primitives/Center/styled.es.js';
import '../../../primitives/Group/Group.es.js';
import '../../../primitives/Grid/Grid.es.js';
import '../../../primitives/Level/Level.es.js';
import '../../../primitives/Shelf/Shelf.es.js';
import '../../../primitives/Portal/Portal.es.js';
import '../../../primitives/Hidden/Hidden.es.js';
import '../../../primitives/Media/Media.es.js';
import '../../../primitives/Dialog/Dialog.es.js';
import '../../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../../primitives/Popper/Popper.es.js';
import '../../../primitives/DragHandle/DragHandle.es.js';
import '../../../primitives/Pin/Pin.es.js';
import { Progress } from '../../Progress/Progress.es.js';
import Styled from './styled.es.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(__getOwnPropSymbols(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
  }

  return target;
};

var DotSelected = function DotSelected(_ref) {
  var onClick = _ref.onClick,
      dotIndex = _ref.dotIndex,
      transitionDelay = _ref.transitionDelay;

  var _useState = useState(0),
      progress = _useState[0],
      setProgress = _useState[1];

  var handleClick = function handleClick() {
    onClick(dotIndex);
  };

  useEffect(function () {
    setProgress(transitionDelay ? 1 : 0);
  }, [transitionDelay]);
  return (
    /* @__PURE__ */
    React.createElement(Styled.DotWrapper, {
      as: "button",
      onClick: handleClick,
      tabIndex: -1
    },
    /* @__PURE__ */
    React.createElement(Styled.AbsoluteBox, null,
    /* @__PURE__ */
    React.createElement(Progress, {
      size: 16,
      strokeWidth: 6,
      progress: progress,
      transitionDelay: transitionDelay
    })))
  );
};

var DotUnSelected = function DotUnSelected(_ref2) {
  var onClick = _ref2.onClick,
      dotIndex = _ref2.dotIndex;

  var handleClick = function handleClick() {
    onClick(dotIndex);
  };

  return (
    /* @__PURE__ */
    React.createElement(Styled.DotWrapper, {
      as: "button",
      onClick: handleClick,
      tabIndex: -1
    },
    /* @__PURE__ */
    React.createElement(Styled.AbsoluteBox, {
      borderRadius: "50%",
      border: "4px solid transparent"
    },
    /* @__PURE__ */
    React.createElement(Styled.Circle, {
      opacity: 0.35,
      backgroundColor: "neutral.100"
    })))
  );
};

var DotNavigation = function DotNavigation(_a) {
  var _b = _a,
      dotPosition = _b.dotPosition,
      dotSize = _b.dotSize,
      length = _b.length,
      currentSelection = _b.currentSelection,
      onClick = _b.onClick,
      _b$transitionDelay = _b.transitionDelay,
      transitionDelay = _b$transitionDelay === void 0 ? 0 : _b$transitionDelay,
      props = __objRest(_b, ["dotPosition", "dotSize", "length", "currentSelection", "onClick", "transitionDelay"]);

  var MemoizedDots = useMemo(function () {
    return new Array(length).fill(true).map(function (_, index) {
      return (
        /* @__PURE__ */
        React.createElement(Styled.GroupItem, {
          key: "$indicator-" + index
        }, currentSelection === index &&
        /* @__PURE__ */
        React.createElement(DotSelected, {
          onClick: onClick,
          dotIndex: index,
          transitionDelay: transitionDelay
        }), currentSelection !== index &&
        /* @__PURE__ */
        React.createElement(DotUnSelected, {
          onClick: onClick,
          dotIndex: index
        }))
      );
    });
  }, [currentSelection, length, onClick, transitionDelay]);
  return (
    /* @__PURE__ */
    React.createElement(Box, null,
    /* @__PURE__ */
    React.createElement(Styled.GroupWrapper, __spreadValues({
      dotSize: dotSize,
      dotPosition: dotPosition,
      gutter: "sm",
      justifyContent: "center"
    }, props), MemoizedDots))
  );
};

export { DotNavigation as default };